import { render } from "./OrderReturnProduct.vue?vue&type=template&id=47e31b3e"
import script from "./OrderReturnProduct.vue?vue&type=script&lang=js"
export * from "./OrderReturnProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__